import { ConnectionInfo } from "utils/serverless-hub";

import { User } from "store/environments/tenants/users/users-types";
import { DataImport } from "store/environments/tenants/data-import/data-import-types";
import { CultureSettings } from "store/environments/tenants/culture-settings/culture-settings-types";
import { Company } from "store/environments/tenants/companies/companies-types";
import {
    Features,
    OcrConfiguration,
} from "store/environments/tenants/tenant-configurations/tenant-configurations-types";

export const SET_ENROLL_WORKFLOW = "enrollTenant/SET_ENROLL_WORKFLOW";
export const UPDATE_STEP = "enrollTenant/UPDATE_STEP";
export const SET_ACTIVE_STEP = "enrollTenant/SET_ACTIVE_STEP";
export const SET_ACTIVE_STEP_DATA = "enrollTenant/SET_ACTIVE_STEP_DATA";
export const SET_ENROLL_CACHE = "enrollTenant/SET_ENROLL_CACHE";
export const SET_INITIAL_STATE = "enrollTenant/SET_INITIAL_STATE";
export const SET_ORCHESTRATOR_INSTANCE_ID =
    "enrollTenant/SET_ORCHESTRATOR_INSTANCE_ID";
export const CLEAR_SECRET_ACTIVE_STEP_DATA =
    "enrollTenant/CLEAR_SECRET_ACTIVE_STEP_DATA";

export enum StepType {
    Manual,
    Automated,
}

export enum StepStatus {
    NotStarted,
    Running,
    Failed,
    Success,
    Pending,
    Skipped,
}

export interface EnrollStep {
    id: string;
    name: string;
    type: StepType;
    order: number;
    data: string | null;
    details: string;
    status: StepStatus;
    logs: string | null;
    // Related only to step 6. Otherwise, it should be null by default
    isFinalized: boolean | null;
}

export interface EnrollStepData {
    actionDescription: string;
    actionMessage: string | null;
}

export interface EnrollCache {
    customerId: string;
    tenantMoniker?: string | null;
    tenantId: string;
    tenantName: string;
    authenticationMethod?: string | null;
}

export enum EnrollStatus {
    NotStarted = 0,
    InProgress,
    Failed,
    Success,
    Terminating,
}

export interface EnrollWorkflow {
    id: string;
    steps: EnrollStep[];
    status: EnrollStatus;
}

export interface StepActivityMessage {
    Name: string;
    Status: StepStatus;
    Message: string;
    Data: any;
}

export interface IState {
    orchestratorInstanceId: string | null;
    enrollTenant: EnrollWorkflow | null;
    hubInfo: ConnectionInfo | null;
    enrollCache: EnrollCache | null;
    activeStep: EnrollStep | null;
}

export interface ISetOrchestratorInstanceId {
    type: typeof SET_ORCHESTRATOR_INSTANCE_ID;
    orchestratorInstanceId: string | null;
}

export interface ISetInitialState {
    type: typeof SET_INITIAL_STATE;
}

export interface ISetActiveStep {
    type: typeof SET_ACTIVE_STEP;
    activeStep: EnrollStep | null;
}

export interface IClearSecretActiveStepData {
    type: typeof CLEAR_SECRET_ACTIVE_STEP_DATA;
    data: ErpIntegrationData;
}

export interface ISetEnrollCache {
    type: typeof SET_ENROLL_CACHE;
    enrollCache: EnrollCache;
}

export interface ISetActiveStepData {
    type: typeof SET_ACTIVE_STEP_DATA;
    data: string | null;
}

export interface ISetEnrollTenant {
    type: typeof SET_ENROLL_WORKFLOW;
    enrollTenant: EnrollWorkflow | null;
}

export interface IUpdateStepStatus {
    type: typeof UPDATE_STEP;
    step: EnrollStep;
}

export interface SelectCustomerData {
    id: string;
    name: string;
    customer: {
        id: string;
        name: string;
    };
}

export interface ErpIntegrationData {
    username: string;
    password: string;
    axUrl: string;
    secretExpirationDate: Date | null;
    tokenUrl: string;
    axAuthority: string;
    axClientId: string;
    axClientSecret: string;
    azureAdResource: string;
}

export enum IntegrationFormType {
    Password,
    Secret,
}

export interface FirstAdminData {
    isD365RoleDooapRequired: true;
    users: User[];
}

/* eslint-disable @typescript-eslint/no-empty-object-type */
export interface GuestTenantsData {}

export interface InitializeSettingsAndFeaturesData {
    cultureSettings: CultureSettings;
    features: Features;
    ocrConfiguration: OcrConfiguration;
}

export type StepApproveDataTypes =
    | SelectCustomerData
    | ErpIntegrationData
    | FirstAdminData
    | GuestTenantsData
    | InitializeSettingsAndFeaturesData
    | DataImport[]
    | Company[]
    | boolean;

export type Actions =
    | ISetActiveStep
    | ISetEnrollTenant
    | IUpdateStepStatus
    | ISetOrchestratorInstanceId
    | IClearSecretActiveStepData
    | ISetActiveStepData
    | ISetEnrollCache
    | ISetInitialState;
